module.exports = __webpack_public_path__ + "static/media/bg.8b00180f.svg";